import { MarketingDrawer, Logo } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { Header, Header2, Header3 } from '@app/components/general/header'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { classNames } from '@app/utils/classes'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { companyName } from '@app/configs'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/brand-assets',
    }),
  }
}

// BLOCK THE PAGE IF NOT FULL SPLIT BRAND
function BrandAssets() {
  const { t } = useTranslation('brand-assets')

  return (
    <MarketingDrawer>
      <div>
        <SectionContainer container block>
          <Header>{t('header')}</Header>
          <Paragraph>{t('header-details')}</Paragraph>
          <Header2>{t('official')}</Header2>
          <Paragraph className='text-sm'>{t('official-details')}</Paragraph>
          <Header3>{t('rules')}</Header3>
          <Paragraph>{t('rules-details')}</Paragraph>
          <div className={'pt-6'}>
            <div className='flex flex-col md:flex-row flex-1 border rounded px-12 py-16 gap-x-4 gap-y-2'>
              <div className='flex flex-1 place-items-center place-content-center space-x-2'>
                <Logo width={100} height={62} t={t} />
                <strong className='text-xl md:text-3xl lg:text-4xl'>
                  {companyName}
                </strong>
              </div>
              <div className='space-y-2 flex-1'>
                <Paragraph className='text-lg md:text-xl font-semibold'>
                  {t('a11y-logos')}
                </Paragraph>
                <Paragraph className='text-gray-800 dark:text-gray-100'>
                  {t('a11y-logos-d')}
                </Paragraph>
                <form
                  method='get'
                  action={process.env.NEXT_PUBLIC_BRAND_ASSETS_LOCATION}
                >
                  <button
                    className={classNames(
                      'border dark:border-gray-700 relative cursor-pointer inline-flex items-center space-x-2 text-center font-regular transition ease-out',
                      'duration-200 rounded outline-none transition-all outline-0 focus-visible:outline-4 focus-visible:outline-offset-1 text-scale-1200 bg-scale-100 hover:bg-scale-300 shadow-scale-600 hover:bordershadow-scale-700 dark:shadow-scale-700 dark:hover:shadow-scale-800 dark:bg-scale-500 dark:hover:bg-scale-600 focus-visible:outline-brand-600 shadow-sm text-xs px-2.5 py-1',
                      'hover:text-blue-600 hover:border-blue-600 dark:hover:border-blue-600'
                    )}
                    type='submit'
                  >
                    <span className='truncate'>{t('dl-kit')}</span>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='14'
                      height='14'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'></path>
                      <polyline points='7 10 12 15 17 10'></polyline>
                      <line x1='12' y1='15' x2='12' y2='3'></line>
                    </svg>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </SectionContainer>
      </div>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { BrandAssets },
  {
    translation: 'brand-assets',
  }
)
